import RtrImage from "components/source/shared/rtr-image";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { setReviewModalIndex, setReviewModalOpen } from "slices/pdp-slice";

export default function ThumbnailImages(props) {
  const dispatch = useDispatch();

  return (
    <>
      {props.reviewsThumbnailPhotos?.map((reviewsCoverPhoto, index) => {
        const imgSrc = reviewsCoverPhoto.hasCroppedPhoto
          ? reviewsCoverPhoto?.coverPhoto?.urls?.imageCropped
          : reviewsCoverPhoto?.coverPhoto?.urls?.image;

        return (
          <button
            data-test-id="review-thumbnail-carousel__child"
            onClick={() => {
              dispatch(setReviewModalIndex(index));
              dispatch(setReviewModalOpen(true));
            }}
            className="flex-shrink-0"
            key={reviewsCoverPhoto?.reviewId}>
            <RtrImage
              key={reviewsCoverPhoto?.reviewId}
              className="mr-0.5 h-16 md:h-20"
              alt={`review thumbnail images ${index}`}
              itemProp={"image"}
              src={imgSrc}
              sizes={"(max-width: 480px) 80vw, (max-width: 1024px) 50vw, 1080px"} // ideally the browser would use src as a default if the srcset media width doesn't match, but it's not always smart enough so specificying a size for 1080 here
            />
          </button>
        );
      })}
    </>
  );
}

ThumbnailImages.propTypes = {
  reviewsThumbnailPhotos: PropTypes.arrayOf(PropTypes.object).isRequired,
};
